module.exports = __webpack_public_path__ + "img/playstore.0ab4b048.png";